
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserStateService {
  public rolesSubject = new BehaviorSubject<string[]>([]);

  // Method to set roles
  setRoles(roles: string[]): void {
    this.rolesSubject.next(roles);
  }
}